import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { UserSettingsDto } from '@lfw/roesberg.liveforms.core';

import { NgxIndexedDBService } from 'ngx-indexed-db';

@Injectable({
  providedIn: 'root'
})
export class OfflineSettingsService {
  private indexDbClient = inject(NgxIndexedDBService);

  public getUserOffline(): Observable<UserSettingsDto> {
    return this.indexDbClient.getAll<UserSettingsDto>('userSettings').pipe(
      switchMap((userSettings) => {
        if (userSettings.length > 1) {
          return this.indexDbClient.clear('userSettings').pipe(
            map(() => {
              throw new Error('more then one userSetting found, clearing storage');
            })
          );
        }
        if (userSettings.length === 1) {
          return this.indexDbClient.clear('userSettings').pipe(
            map(() => {
              throw new Error('no userInformation found in storage');
            })
          );
        }
        return of(userSettings);
      }),
      map((userSettings) => userSettings.pop()),
      filter((userSetting: UserSettingsDto | undefined): userSetting is UserSettingsDto => !!userSetting)
    );
  }

  public saveUserOffline(userSettings: UserSettingsDto) {
    return this.indexDbClient
      .clear('userSettings')
      .pipe(switchMap(() => this.indexDbClient.update('userSettings', userSettings)));
  }
}
